import { REQUIRED_OPTION } from "@constants/index";

export const validateOption = (option?: IOption) => {
    const entries = option && typeof option === 'object' ? Object.entries(option) : [];
    let optionName;

    const isNotValid = entries.some(v => {
        const key = v[0];
        const value = v[1];
        if(REQUIRED_OPTION.hasOwnProperty(key)  && !value && typeof value !== 'boolean') {
            optionName = key;
            return true;
        }
        return false;
    });

    if(isNotValid) {
        console.error(`${optionName} 값이 없습니다. 옵션에 해당 값을 추가해주세요.`);
    }

    return !isNotValid;
};